/**
 * Hex code regex for 3, 6 and 8 symbols. Only accepts A-F and 0-9.
 */
const hexCodeRegex = /^([a-fA-F0-9]{8}|[a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/
export default hexCodeRegex
